import { Column } from '@/components/container/Container';
import Spacing from '@/components/container/Spacing';
import { Skeleton } from 'primereact/skeleton';

const CardContentSkeleton = () => {
	return (
		<Column>
			<Skeleton width="215px" height="24px" className="skeleton" />
			<Spacing height="h-2" />
			<Skeleton width="83px" height="52px" className="skeleton" />
			<Spacing height="h-4" />
			<Skeleton height="96px" className="skeleton" />
		</Column>
	);
};

export default CardContentSkeleton;
